module.exports = __webpack_public_path__ + "img/header-weddingRingsPlatinum.ee724ac.webp";